<template>
  <ul class="desktop-mega-menu__list">
    <li
      v-for="(sublink, index) in sublinksArray"
      :key="index"
      class="desktop-mega-menu__list-item"
    >
      <h3
        class="desktop-mega-menu__list-title"
      >
        <a
          :href="sublink.url"
          class="link desktop-mega-menu__list-link"
          :class="{ 'has-badge': sublink.badge }"
        >
          <span
            class="desktop-mega-menu__link-title"
            v-text="sublink.title"
          />
          <badge
            v-if="sublink.badge"
            class="desktop-mega-menu__badge"
            :label="sublink.badge.label"
            :background-colour="sublink.badge.backgroundColour"
            :text-colour="sublink.badge.textColour"
          />
        </a>
      </h3>
      <ul
        v-if="sublink.grandlinks?.length"
        class="desktop-mega-menu__grandlist"
      >
        <li
          v-for="(grandlink, idx) in sublink.grandlinks"
          :key="idx"
          class="desktop-mega-menu__grandlist-item"
        >
          <a
            :href="grandlink.url"
            class="desktop-mega-menu__grandlist-link"
            :class="{ 'has-badge': grandlink.badge }"
          >
            <span
              class="desktop-mega-menu__grandlink-title"
              v-text="grandlink.title"
            />
            <badge
              v-if="grandlink.badge"
              class="desktop-mega-menu__badge"
              :label="grandlink.badge.label"
              :background-colour="grandlink.badge.backgroundColour"
              :text-colour="grandlink.badge.textColour"
            />
          </a>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>

/**
 * Component: Mega Menu List
 * -----------------------------------------------------------------------------
 * @param {Array}  [sublinks] - Formatted 2nd level links array.
 * @param {Number} [maxLength] - The maximum number of links that will be displayed in the mega menu.
 */

import Badge from '~components/badge/badge'

export default {
  name: 'MegaMenuList',

  components: {
    Badge,
  },

  props: {
    sublinks: {
      type: Array,
      default: () => [],
    },
    maxLength: {
      type: Number,
      default: null,
    },
  },

  computed: {

    /**
     * Truncate `sublinks` array based on the passed max number of displayed
     * sublinks (for different types of megamenus)
     */
    sublinksArray() {
      if (!this.maxLength) {
        return this.sublinks
      }

      return this.sublinks.slice(0, Number(this.maxLength)) || []
    },
  },
}
</script>
